import { CAApiError, CAApiErrorCode } from '../contracts/ca.api.contracts';

export class CAServiceError extends Error implements CAApiError {
  code: CAApiErrorCode;
  details?: unknown;

  constructor(code: CAApiErrorCode, message: string, details?: unknown) {
    super(message);
    this.name = 'CAServiceError';
    this.code = code;
    this.details = details;
  }
}

export const asCAServiceError = (error: unknown): CAServiceError => {
  if (error instanceof CAServiceError) {
    return error;
  }
  if (error instanceof Error) {
    return new CAServiceError('UNKNOWN_ERROR', error.message);
  }
  return new CAServiceError('UNKNOWN_ERROR', 'Unexpected error');
};

export const isFeatureUnavailableError = (error: unknown): boolean => {
  const serviceError = asCAServiceError(error);
  return serviceError.code === 'NOT_FOUND' || serviceError.code === 'FORBIDDEN';
};
